import {toFormData} from "../utils/toFormData";
import {tokenAndRoute} from "../utils/tokenAndRoute";
import errors from '../../components/Forms/errors'
import {loaderMixin} from "../utils/loaderMixin";
import uploadFile from '../../components/uploadFileBig'
import {mapActions} from "vuex";
import {sidebarState} from "../utils/sidebarState";

export const singleSettings = {
  props: {
    thing: {
      type: [Object, String]
    }
  },
  mixins: [tokenAndRoute, toFormData, loaderMixin, sidebarState],
  components: {
    uploadFile,
    errors
  },
  data() {
    return {
      avatarFile: '',
      avatarChanged: false,
      avatarDel: false,
      disabled: true,
      name: '',
      tag: '',
      desc: '',
      loading: false
    }
  },
  computed: {

    permissionLevel() {
      return this.thing.permission_level
    },
    enableEdit() {
      return this.permissionLevel > 1
    },
    disableEdit() {
      return this.permissionLevel < 2
    },
    enableDel() {
      return this.permissionLevel > 2
    }
  },
  watch: {
    thing(val) {
      if (val) {
        if (!this.$route.name == 'journalItem') {
          this.setThingParams(val)
        }
      }
    }
  },
  methods: {
    ...mapActions({
      updateThing: 'things/updateDevice',
      updateGroup: 'things/updateDeviceGroup',
      loadThing: 'things/getDevice',
      loadGroup: 'things/getGroup',
      clearAvatar: 'things/cleadDeviceImg',
      clearAvatarGroup: 'things/clearGroupImg',
      setNewAvatar: 'things/setNewAvatar',
    }),
    uploadAvatar(file) {
      this.avatarFile = file;
      this.avatarChanged = true
    },
    delAvatar() {
      this.avatarFile = '';
      this.avatarDel = true
      this.setNewAvatar(false)
    },

  }
}
